import { useRef } from "react";
import { Typography } from "@mui/material";
import { DotLegalTooltip } from "@dotlegal/dotlegal-ui-components";
import { useIsOverflowing } from "@common/hooks/useIsOverflowing";
import { isNullOrWhitespace } from "@common/stringOperations";

export interface SavedViewNameProps {
    name: string;
    description: string | undefined;
}

// Not a DotLegalHeader: its own overflow tooltip can only show the name, and neither its placement nor whether the name
// is cut short is exposed, so the description could not join it
function SavedViewName({ name, description }: SavedViewNameProps) {
    const nameRef = useRef<HTMLSpanElement>(null);
    const isNameCutShort = useIsOverflowing(nameRef, name);
    const tooltipText = [isNameCutShort ? name : undefined, description].filter((text) => !isNullOrWhitespace(text)).join("\n\n");

    // Opens to the left so it does not cover the views below it; the menu is anchored to the right of the page, which
    // leaves room on that side
    return (
        <DotLegalTooltip text={tooltipText} position="left">
            <Typography
                ref={nameRef}
                sx={(theme) => ({
                    minWidth: 0,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    fontSize: theme.typography.pxToRem(14),
                    fontWeight: 400,
                    color: theme.palette.primary.dark,
                })}
            >
                {name}
            </Typography>
        </DotLegalTooltip>
    );
}

export default SavedViewName;
